import { NonNumericOrderDto } from '@planning/app/api'
import { ReleaseStatus } from '@planning/pages/Releases/models/ReleaseStatus'
import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'

const getNonNumericReleaseStatus = (nonNumericRelease: NonNumericOrderDto) => {
  if (nonNumericRelease.amount === nonNumericRelease.fulfilled) {
    return ReleaseStatus.Fulfilled
  } else if (nonNumericRelease.fulfilled > 0) {
    return ReleaseStatus.InProgress
  } else {
    return ReleaseStatus.Open
  }
}

const getNumericReleaseStatus = (nonNumericRelease: INumericReleaseItem) => {
  if (
    nonNumericRelease.assigned > 0 &&
    nonNumericRelease.assigned === nonNumericRelease.fulfilled
  ) {
    return ReleaseStatus.Fulfilled
  } else if (nonNumericRelease.fulfilled > 0) {
    return ReleaseStatus.InProgress
  } else {
    return ReleaseStatus.Open
  }
}

export { getNonNumericReleaseStatus, getNumericReleaseStatus }
